export default "__VITE_ASSET__CRfa4_TD__"